import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { HelpdeskAccessRulesKeyEnum } from './helpdesk-access-rules-key.enum';
import { HelpdeskAccessRulesConst } from './helpdesk-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class HelpdeskAccessService extends BaseAccessService<HelpdeskAccessRulesKeyEnum> {
  public constructor() {
    super(HelpdeskAccessRulesConst);
  }

  public get helpdeskRights() {
    return {
      canReadHelpdesk: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_READ]
      ),
      canWriteHelpdesk: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_WRITE]
      ),

      canReadTaskTypes: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_TYPE_READ]
      ),
      canWriteTaskTypes: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_TYPE_WRITE]
      ),

      canReadTemplates: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TEMPLATE_READ]
      ),
      canWriteTemplates: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TEMPLATE_WRITE]
      ),

      canReadEmailSettings: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EMAIL_SETTINGS_READ]
      ),
      canWriteEmailSettings: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EMAIL_SETTINGS_WRITE]
      ),

      canReadFieldsSettings: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_FIELDS_SETTINGS_READ]
      ),
      canWriteFieldsSettings: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_FIELDS_SETTINGS_WRITE]
      ),

      canReadEAVEntityType: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EAV_ENTITY_TYPE_READ]
      ),
      canWriteEAVEntityType: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EAV_ENTITY_TYPE_WRITE]
      )
    };
  }

  public get helpdeskPermissions() {
    return {
      canReadAllTasks: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_READ_ALL_TASKS]
      ),
      canEditOtherUsersTasks: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EDIT_OTHER_USERS_TASKS]
      ),
      canDeleteTasks: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DELETE_TASKS]
      ),
      canDeleteOtherUserComments: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DELETE_OTHER_USER_COMMENTS]
      ),
      canAnswerWithAI: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_ANSWER_WITH_AI]
      ),
      canDetermineBestAnswer: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DETERMINE_BEST_ANSWER]
      ),
      canMergeHdTasks: this.globalService.isAccessRule(
        HelpdeskAccessRulesConst[HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_MERGE_HD_TASKS]
      )
    };
  }
}
